import styled from 'styled-components';
import { H3 } from '../../../base/typography';

export const Wrapper = styled.div``;

export const CardWrapper = styled.div`
	border: 1px solid #ddd;
	border-radius: 4px;
	height: 100%;
`;

export const Heading = styled(H3)`
	text-align: center;
	border-bottom: 4px solid #df0000;
	margin: 1rem 2rem;
	padding-bottom: 15px;
`;

export const Content = styled.div`
	padding: 0 2rem;
	strong {
		font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	}

	p {
		margin-bottom: 0.5rem;
	}
`;
